import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg" }, " Your Invitations ")
], -1)
const _hoisted_2 = {
  class: "py-2",
  "data-test-id": "user-email-bar"
}
const _hoisted_3 = { class: "py-2" }
const _hoisted_4 = { class: "user-section" }
const _hoisted_5 = {
  class: "w-auto table-fixed ml-4 md:ml-0",
  "data-test-id": "invite-list"
}
const _hoisted_6 = { class: "grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_email_form = _resolveComponent("email-form")!
  const _component_pending_invites = _resolveComponent("pending-invites")!
  const _component_nominated_users = _resolveComponent("nominated-users")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_email_form)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_pending_invites),
            _createVNode(_component_nominated_users, { onCloseSidebar: _ctx.closeSidebar }, null, 8, ["onCloseSidebar"])
          ])
        ])
      ])
    ])
  ]))
}